<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>



    <EntityForm :entity="config" :model="model" @submit="save" />


</template>

<script setup>

import { reactive } from "vue"
import { entityRegistry } from "@/entities/entity.registry"

const props = defineProps({
    entity: String
})

const config = entityRegistry[props.entity]

const fields = config.fields

const model = reactive({})

function save() {

    console.log("update", props.entity, model)

}

</script>